module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_09.cae0dac6.jpg";